import { useDispatch, useSelector } from 'react-redux';

import { Checkbox, ICheckboxOptions } from '../../../../../component';

import { RootState } from '../../../../../reducer';

import './averageIncomeOptions.scss';
import { updateOptions } from '../../redux/dataLayers.actions';

function AverageIncomeOptions() {
  const dispatch = useDispatch();
  const {
    dataLayersState: { polygons, dataLayers },
  } = useSelector((state: RootState) => state);

  const togglePoligon = (selectedItem: ICheckboxOptions) => {
    const averageIncome = polygons.averageIncome as (google.maps.Polygon & {
      fillColor: string;
    })[];
    averageIncome.forEach((polygon) => {
      if (polygon?.fillColor === selectedItem.color) {
        polygon.setVisible(!polygon.getVisible());
      }
    });
  };

  const toggleCheckbox = (selectedItem: ICheckboxOptions) => {
    const updatedOptionsList = dataLayers.averageIncome.options.map(
      (option) => {
        if (option.id === selectedItem.id) {
          return {
            ...option,
            checked: !option.checked,
          };
        }
        return option;
      }
    );
    dispatch(
      updateOptions({ name: 'averageIncome', options: updatedOptionsList })
    );
  };

  const onCheckboxClick = (selectedItem: ICheckboxOptions | boolean) => {
    if (typeof selectedItem === 'boolean') return;
    toggleCheckbox(selectedItem);
    if (!!polygons.averageIncome.length) togglePoligon(selectedItem);
  };

  return (
    <Checkbox
      cy="AverageFamilyIncomeSwitch"
      name="averageFamilyIncome"
      type="checkbox list"
      action={onCheckboxClick}
      options={dataLayers.averageIncome.options}
      optionLabel="label"
      optionValue="color"
    />
  );
}

export default AverageIncomeOptions;
